import React from "react";
import { Form, FormProps } from "@emisgroup/ui-form";

interface CustomFormProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
}

type FrmProps = FormProps & CustomFormProps;

/**
 * Responsible for rendering the form
 * @returns form and its elements
 */
export const UIForm: React.FC<FrmProps> = (props: FrmProps) => {
  const { children } = props;
  return (
    <Form
      {...props}
    >
      {children}
    </Form>
  );
};
